const BasicProfileAction = {
  FETCH_EDUCATION_SUCCESS: 'FETCH_EDUCATION_SUCCESS',
  FETCH_EDUCATION_FAIL: 'FETCH_EDUCATION_FAIL',
  FETCH_CLOUD_CERTIFICATE_TYPES_SUCCESS: 'FETCH_CLOUD_CERTIFICATE_TYPES_SUCCESS',
  FETCH_CLOUD_CERTIFICATE_TYPES_FAIL: 'FETCH_CLOUD_CERTIFICATE_TYPES_FAIL',
  FETCH_USER_CLOUD_CERTIFICATE_SUCCESS: 'FETCH_USER_CLOUD_CERTIFICATE_SUCCESS',
  FETCH_USER_CLOUD_CERTIFICATE_FAIL: 'FETCH_USER_CLOUD_CERTIFICATE_FAIL',
  FETCH_USER_SALARY_TYPE_SUCCESS: 'FETCH_USER_SALARY_TYPE_SUCCESS',
  FETCH_USER_SALARY_TYPE_FAIL: 'FETCH_USER_SALARY_TYPE_FAIL',
  FETCH_ALL_COUNTRIES_SUCCESS: 'FETCH_ALL_COUNTRIES_SUCCESS',
  FETCH_ALL_COUNTRIES_FAIL: 'FETCH_ALL_COUNTRIES_FAIL',
  FETCH_DEVELOPER_AVAILABILITY_STATUS_SUCCESS: 'FETCH_DEVELOPER_AVAILABILITY_STATUS_SUCCESS',
  FETCH_DEVELOPER_AVAILABILITY_STATUS_FAIL: 'FETCH_DEVELOPER_AVAILABILITY_STATUS_FAIL',
  FETCH_JOB_ROLE_TYPE_SUCCESS: 'FETCH_JOB_ROLE_TYPE_SUCCESS',
  FETCH_JOB_ROLE_TYPE_FAIL: 'FETCH_JOB_ROLE_TYPE_FAIL',
  FETCH_BASIC_INFO_SUCCESS: 'FETCH_BASIC_INFO_SUCCESS',
  FETCH_BASIC_INFO_FAIL: 'FETCH_BASIC_INFO_FAIL',
  FETCH_CURRENCY_RATE_DATA_SUCCESS: 'FETCH_CURRENCY_RATE_DATA_SUCCESS',
  FETCH_CURRENCY_RATE_DATA_FAIL: 'FETCH_CURRENCY_RATE_DATA_FAIL',
  CHANGE_INPUT_VALUE: 'CHANGE_INPUT_VALUE',
  REQUEST_LOADING: 'REQUEST_LOADING',
  FORM_SUBMITTING: 'FORM_SUBMITTING',
  UPDATE_STATE_DATA: 'UPDATE_STATE_DATA',
  POST_UPDATE_STATE_DATA_SUCCESS: 'POST_UPDATE_STATE_DATA_SUCCESS',
  POST_UPDATE_STATE_DATA_FAIL: 'POST_UPDATE_STATE_DATA_FAIL',
  RESET_STORE: 'RESET_STORE',
  CLEAR_ALL_ERRORS: 'CLEAR_ALL_ERRORS'
};

const RegexConstants = {
  GITHUB_URL : /^(https?:\/\/)([w]{0,3}.)?github\.com\/[\w-.\/]{2,100}$/
}

export {
  BasicProfileAction,
  RegexConstants
};
